import { render, staticRenderFns } from "./gestionesListasParaAprobacion.vue?vue&type=template&id=4f650467&scoped=true"
import script from "./gestionesListasParaAprobacion.vue?vue&type=script&lang=js"
export * from "./gestionesListasParaAprobacion.vue?vue&type=script&lang=js"
import style0 from "./gestionesListasParaAprobacion.vue?vue&type=style&index=0&id=4f650467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f650467",
  null
  
)

export default component.exports